import React, { useContext, createContext, useState, Suspense } from "react";

export const UserContext = createContext({
  first_name: "",
  last_name: "",
  id: 0,
  roles: [],
  auth: false,
});

export const UserProvider = ({ children }) => {
  // User is the name of the "data" that gets stored in context
  const [user, setUser] = useState({
    first_name: "",
    last_name: "",
    id: 0,
    roles: [],
    auth: false,
  });

  // Login updates the user data with a name parameter
  const login = (user) => {
    setUser(() => ({
      ...user,
      auth: true,
    }));
  };

  // Logout updates the user data to default
  const logout = () => {
    setUser(() => ({
      first_name: "",
      last_name: "",
      id: 0,
      roles: [],
      auth: false,
    }));
  };

  return (
    <UserContext.Provider value={{ user, login, logout }}>
      {children}
    </UserContext.Provider>
  );
};
